@if (picture) {
    <picture
        [rootMargin]="rootMargin"
        intersectOnce="true"
        [intersectionEnabled]="lazyLoad"
        (finderIntersection)="onIntersectionObserver($event)"
        [ngStyle]="{aspectRatio: loaded ? 'auto': skeletonAspectStyling.aspectRation}"
        >
        @if (picture.desktop && picture.mobile) {
        <source
            [srcset]="picture.mobile"
            sizes="100vw"
            [media]="picture.media"
        />
        }
        <img class="picture-img"
            height="100%"
            width="100%"
            [attr.fetchpriority]="loadingType === 'eager' ? 'high' : 'auto'"
            [ngClass]="{'loading': loading, 'loaded': loaded}"
            [attr.alt]="picture.alt || ''"
            [attr.aria-label]="picture.alt !== '' ? picture.alt : null"
            [src]="picture.desktop || picture.mobile"
            [srcset]="imageSrc"
            sizes="100vw"
            [attr.loading]="loadingType"
            (load)="onLoad($event)"
        />
    </picture>
}
